import { memo } from "react";
import { Outlet } from "react-router-dom";

import * as css from "./app-shell.module.css";
import { ImpersonationBanner } from "./impersonation-banner";
import { PageErrorBoundary } from "./page-error-boundary";
import { Sidebar } from "./sidebar";

/**
 * The two-pane shell: 240px sidebar + main content area. Wraps every
 * authenticated route via the Router config. The sidebar is sticky
 * and full-height; the main column scrolls. Topbar lives inside each
 * page so the breadcrumb trail can vary per route.
 *
 * The wrapping `<div class="partners-app-shell">` scopes the design's
 * Geist token block so the login page (Inter + redo-web tokens) is
 * untouched.
 */
export const AppShell = memo(function AppShell() {
  return (
    <div className={`partners-app-shell ${css.shell}`}>
      <Sidebar />
      <main className={css.main}>
        <ImpersonationBanner />
        <PageErrorBoundary>
          <Outlet />
        </PageErrorBoundary>
      </main>
    </div>
  );
});
